import { apiRequest, initializeCsrf } from "@/lib/api";
import type {
  AuthResponse,
  LoginRequest,
  RequestMagicLinkRequest,
  RequestMagicLinkResponse,
  RegisterRequest,
  VerifyMagicLinkRequest,
  VerifyMagicLinkResponse,
} from "@/types/auth";

export async function requestMagicLink(data: RequestMagicLinkRequest): Promise<RequestMagicLinkResponse> {
  await initializeCsrf();
  return apiRequest<RequestMagicLinkResponse>("/auth/magic-link/request", { method: "POST", body: JSON.stringify(data) });
}

export async function verifyMagicLink(data: VerifyMagicLinkRequest): Promise<VerifyMagicLinkResponse> {
  await initializeCsrf();
  return apiRequest<VerifyMagicLinkResponse>("/auth/magic-link/verify", { method: "POST", body: JSON.stringify(data) });
}

export async function login(data: LoginRequest): Promise<AuthResponse> {
  await initializeCsrf();

  return apiRequest<AuthResponse>("/auth/login", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function register(data: RegisterRequest): Promise<AuthResponse> {
  await initializeCsrf();

  return apiRequest<AuthResponse>("/auth/register", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function currentUser(): Promise<AuthResponse> {
  return apiRequest<AuthResponse>("/auth/user");
}

export async function logout(): Promise<void> {
  await initializeCsrf();
  await apiRequest("/auth/logout", {
    method: "POST",
  });
}
